export const LANGUAGE_CODE_MAPPING = {
  ar: 'Arabic',
  bg: 'Bulgarian',
  bs: 'Bosnian',
  cs: 'Czech',
  da: 'Danish',
  de: 'German',
  el: 'Greek',
  en: 'English',
  es: 'Spanish',
  et: 'Estonian',
  fi: 'Finnish',
  fr: 'French',
  he: 'Hebrew',
  hi: 'Hindi',
  hr: 'Croatian',
  hu: 'Hungarian',
  id: 'Indonesian',
  is: 'Icelandic',
  it: 'Italian',
  ja: 'Japanese',
  lt: 'Lithuanian',
  lv: 'Latvian',
  mk: 'Macedonian',
  ms: 'Malay',
  mt: 'Maltese',
  nb: 'Norwegian',
  nl: 'Dutch',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  ru: 'Russian',
  sk: 'Slovak',
  sl: 'Slovenian',
  sq: 'Albanian',
  sr: 'Serbian',
  sv: 'Swedish',
  th: 'Thai',
  tl: 'Tagalog',
  tr: 'Turkish',
  vi: 'Vietnamese',
  zh: 'TraditionalChinese',
};
